import { type FunctionComponent, useEffect } from "react";
import type { FormattedTableJob } from "components/job/JobTable/types";
import useUrlBooleanFlags from "hooks/useUrlBooleanFlags";
import { useAppDispatch } from "components/shared/App";
import { setFlags } from "store/slices/query";
import MarkAllAsPaidButton from "./MarkAllAsPaidButton";
import PendingPayoutButton from "./PendingPayoutButton";
import SatNoteSignedButton from "./SatNoteSignedButton";
import SolarButton from "./SolarButton";
import { CLASS_NAMES } from "./constants";
import DownloadCsvButton from "./DownloadCsvButton";

export interface JobListPageActionsProps {
  data: FormattedTableJob[];
}

const JobListPageActions: FunctionComponent<JobListPageActionsProps> =
  function ({ data }) {
    const dispatch = useAppDispatch();

    const {
      values: { solar, satNoteSigned, pendingPayout },
      toggleValue,
    } = useUrlBooleanFlags(["solar", "satNoteSigned", "pendingPayout"]);

    useEffect(() => {
      dispatch(
        setFlags([
          "jobs",
          {
            solar,
            satNoteSigned,
            pendingPayout,
          },
        ])
      );
    }, [solar, satNoteSigned, pendingPayout]);

    return (
      <>
        <div className={CLASS_NAMES.firstRow}>
          <PendingPayoutButton
            active={pendingPayout}
            toggleValue={toggleValue}
          />
          <SatNoteSignedButton
            active={satNoteSigned}
            toggleValue={toggleValue}
          />
          <SolarButton active={solar} toggleValue={toggleValue} />
        </div>
        {pendingPayout && (
          <div className={CLASS_NAMES.row}>
            <DownloadCsvButton data={data} />
            <MarkAllAsPaidButton />
          </div>
        )}
      </>
    );
  };

export default JobListPageActions;
